import { Vault } from '@/features/vaults/types';

export const ethereumTestKeyrock3_2VaultId = 'ethereum-test-keyrock-3-2';

export const ethereumTestKeyrock3_2: Vault = {
  id: ethereumTestKeyrock3_2VaultId,
  type: 'core-vault',
  name: 'test Keyrock 3-2',
  description: '',
  category: 'core-vault',
  address: '0x5596c367d808A8c0AB40F3799ee8d97f37a10Ee5',
  curators: [],
  operator: [],
  points: [{ entity: 'mellow', startTimestamp: 1738573595 }],
  network: 'ethereum',
  networks: [
    {
      network: 'ethereum',
      vaultAddress: '0x5596c367d808A8c0AB40F3799ee8d97f37a10Ee5',
    },
  ],
  baseToken: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
  lpTokenSymbol: 'tKR3-2',
  lpTokenDecimals: 18,
  oracleUpdateInterval: BigInt(86400),
  redeemHandlingInterval: BigInt(3600),
  allocations: {
    showAllocationsTab: true,
  },
  archived: false,
};
